import { createContext } from 'react';

// Define the shape of the AuthContext
interface AuthContextType {
    setToken: (token?: string) => void;
    isAuthenticated: boolean;
}

// Create the AuthContext with a default value of null
export const AuthContext = createContext<AuthContextType | null>(null);
